import { ActionCardAccordionGrid } from '@rsa-digital/evo-shared-components/components/ActionCard';
import React from 'react';
import { unwrapSingleton } from 'helpers/csTypeProcessors';
import { handleAndTrackLinkClick } from 'helpers/navigation';
import { StyledActionCard } from '../styles';
import { ActionCardsData } from '../types';

const AccordionActionCardsBlock: React.FC<{
  action_cards: ActionCardsData;
}> = ({ action_cards }) => (
  <ActionCardAccordionGrid data-cy="AccordionActionCards">
    {action_cards.action_cards.map(
      ({ href, icon, heading, subheading, body, disabled, chevron_icon }, index) => (
        <StyledActionCard
          key={`${heading}-${index}`}
          data-cy="Accordion Action Cards"
          href={href}
          icon={unwrapSingleton(icon)?.icon_code}
          heading={heading}
          subheading={subheading ?? undefined}
          body={body ?? undefined}
          onClick={handleAndTrackLinkClick(href, 'AccordionActionCards', heading)}
          disabled={disabled}
          chevronIcon={unwrapSingleton(chevron_icon)?.icon_code}
        />
      )
    )}
  </ActionCardAccordionGrid>
);

export default React.memo(AccordionActionCardsBlock);
